"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abbreviateCurrencyNumber = exports.abbreviateNumberWithScale = void 0;
var HUNDRED = 100;
var THOUSAND = 1000;
var HUNDRED_THOUSAND = THOUSAND * HUNDRED;
var ONE_MILLION = THOUSAND * THOUSAND;
var abbreviateNumberWithScale = function (shifted, suffix) {
    var numberOfDigits = Math.floor(Math.log10(shifted));
    return "".concat(shifted.toPrecision(numberOfDigits + 2)).concat(suffix);
};
exports.abbreviateNumberWithScale = abbreviateNumberWithScale;
var abbreviateCurrencyNumber = function (num) {
    var normalizedValue;
    if (typeof num === 'string') {
        normalizedValue = parseInt(num, 10);
    }
    else {
        normalizedValue = num;
    }
    if (normalizedValue >= ONE_MILLION &&
        (normalizedValue % ONE_MILLION === 0 || normalizedValue % HUNDRED_THOUSAND === 0)) {
        var shifted = normalizedValue / ONE_MILLION;
        var numberOfDigits = Math.floor(Math.log10(shifted));
        return "".concat(shifted.toPrecision(numberOfDigits + 2), "M");
    }
    if (normalizedValue < ONE_MILLION &&
        normalizedValue >= THOUSAND &&
        (normalizedValue % THOUSAND === 0 || normalizedValue % HUNDRED === 0)) {
        var shifted = normalizedValue / THOUSAND;
        var numberOfDigits = Math.floor(Math.log10(shifted));
        return "".concat(shifted.toPrecision(numberOfDigits + 2), "k");
    }
    return "".concat(normalizedValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
};
exports.abbreviateCurrencyNumber = abbreviateCurrencyNumber;
//# sourceMappingURL=index.js.map